import React, { useEffect, useState } from 'react';
import { Dialog } from '@sas/nova-commons/components/Dialog';
import { useI18n } from '../../locale/I18nContext';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ExplanationState } from '../../store/explanation/explanationState';
import { BusyStateIndicator } from '@sas/nova-commons/components/BusyStateIndicator';
import { ReportContextMenuState } from '../../store/reportContextMenu/ReportContextMenuState';
import { Text } from '@sas/nova-commons/components/Text';
import { useDesignTokens } from '@sas/nova-commons/theme';
import { useIsRTL } from '@sas/nova-commons/locale';
const ExplanationInfoDialogBase = (props) => {
    var _a;
    const localize = useI18n();
    const dt = useDesignTokens();
    const isRTL = useIsRTL();
    // If the request takes more than two seconds, display a loading dialog
    const [timedOut, setTimedOut] = useState(false);
    useEffect(() => {
        setTimedOut(false);
        if (props.explanationData.dataItem) {
            const id = setTimeout(() => setTimedOut(true), 2000);
            return () => clearTimeout(id);
        }
    }, [props.explanationData.dataItem]);
    let dialogProps;
    const content = (_a = props.explanationData.content) !== null && _a !== void 0 ? _a : props.explanationData.warning;
    if (content && props.explanationData.dataItem) {
        // NOTE: set `dir` on <Text> to prevent custom bidi detection in nova.
        // The explain text can have mixed directionality in it, and sometimes a strong LTR
        // character is first and other times it isn't (in the same report). Setting this
        // to match the rest of the page prevents bugs from that ambiguity.
        const dir = isRTL ? 'rtl' : 'ltr';
        dialogProps = {
            isOpen: true,
            title: localize({
                key: `ExplanationInfoDialog.title.fmt`,
                args: { label: props.explanationData.dataItem.label },
            }),
            dismissAction: {
                text: localize({ key: 'ExplanationInfoDialog.close.txt' }),
                onPress: () => props.actions.reset(),
                initialFocus: true,
            },
            children: (React.createElement(Text, { tokens: () => ({ fg: dt.text.basic.fg }), tabIndex: -1, dir: dir }, content)),
        };
    }
    else if (timedOut) {
        dialogProps = {
            isOpen: true,
            title: localize({ key: 'ExplanationInfoDialog.loading.txt' }),
            dismissAction: {
                text: localize({ key: 'ExplanationInfoDialog.cancel.txt' }),
                onPress: () => props.actions.reset(),
                initialFocus: true,
            },
            children: React.createElement(BusyStateIndicator, { active: true }),
        };
    }
    else {
        dialogProps = {
            isOpen: false,
            title: '',
        };
    }
    return (React.createElement(Dialog, Object.assign({ hideAnimation: true, resizable: true, onOpen: props.contextMenuActions.close }, dialogProps)));
};
export const ExplanationInfoDialog = connect((state) => ({ explanationData: state.ui.explanation }), (dispatch) => ({
    actions: bindActionCreators(ExplanationState.actions, dispatch),
    contextMenuActions: bindActionCreators(ReportContextMenuState.actions, dispatch),
}))(ExplanationInfoDialogBase);
